const AOS = require('aos');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();
  checkWindowScroll();
  showMoreItems(jQuery);

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
    submenuOffset();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        var offset = $("header").outerHeight();
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
        }
      }
    });

  // Whitepapers visibility
  $('#whitepaper-cards').showMoreItems({
    itemsPerPage: 15
  });

  $('#case-study-cards').showMoreItems({
    itemsPerPage: 8
  });

  $('#works-cards').showMoreItems({
    itemsPerPage: 8
  });
  
  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  // Contact Form
  setTimeout(function() {
    $('#contact-location-form .email-receipt').attr('value', 'uk').trigger('change');
  }, 500);

  $('#location-select').on('change', function() {
    var selectedLocation = $(this).val();
    $('#contact-location-form .email-receipt').attr('value', selectedLocation).trigger('change');
    $('#location-information').attr('data-title', selectedLocation);
  });

  // // Whitepaper sort
  $('#whitepaper-sort-ref').on('change', function() {
    var sort = $(this).val();
    $('form#whitepaper-form #whitepaper-sort-filter').attr('value', sort);
    $('form#whitepaper-form').trigger('submit');
  });
  
  // Search functionality
  function handleFormSubmissionOnEnter(inputSelector, formSelector) {
    $(inputSelector).on('keydown', function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        $(formSelector).trigger('submit');
      }
    });
  }

  handleFormSubmissionOnEnter('#whitepaper-search', 'form#whitepaper-form');
  handleFormSubmissionOnEnter('#case-study-search', 'form#case-study-form');
  handleFormSubmissionOnEnter('#works-search', 'form#works-form');
  handleFormSubmissionOnEnter('#partner-search', 'form#partner-form');

  // Category dropdown
  function setupViewMore(formContainer, initialContainers, viewMoreButton) {
    if ($(formContainer + ' .radio-container').length > initialContainers) {
      $(formContainer + ' .radio-container:gt(' + (initialContainers - 1) + ')').hide();
      $(formContainer + ' ' + viewMoreButton).show();
    }
  
    $(formContainer + ' ' + viewMoreButton).on('click', function(e) {
      e.preventDefault();
      $(formContainer + ' .radio-container:gt(' + (initialContainers - 1) + ')').toggle();
      $(this).text() === 'View All' ? $(this).text('View Less') : $(this).text('View All');
    });
  }
  
  // Call the function for case study form
  setupViewMore('#case-study-form', 4, '.view-more');
  
  // Call the function for works form
  setupViewMore('#works-form', 4, '.view-more');  

  // Search Modal 
  function searchFix() {
    const heightHeader = $("header").height();
    if ($('.search-bar').hasClass('active')) {
      $('.search-bar').css('top', heightHeader);
    }
  }

  $('.search-btn').on('click', function(){
    $('.search-bar').toggleClass('active');
    $('#header').toggleClass('searching');

    if ($('.search-bar').hasClass('active')) {
      // Focus on the input field
      $('.search-bar input[type="text"]').focus();
    }

    searchFix();
  })

  $('.form-search-btn').on('click', function(e) {
    e.preventDefault();
    $('.form-search-btn').toggleClass('active');
    $('.search-container').toggleClass('active');
  });  

  // Navigation Hover

  $('#navigation > ul > li.nav-item').hover(
    function() {
      $(this).addClass('hovered');
    },
    function() {
      $(this).removeClass('hovered');
    }
  );

  // Job Form.
  if ($('#job-form').length > 0) {
    var fieldValue = $('.job-title').text();
    
    setTimeout(function() {
      $('#job-form .job-role').attr('value', fieldValue).trigger('change');
    }, 500);
  }

  // Search footer

  if($('.search-results').length > 0) {
    $('#footer').addClass('top-divider');
  }

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.addClass("open");
  });

  $(".back-btn").on("click", function() {
    var currentItem = $(this);
    var submenu = currentItem.closest(".submenu");
    submenu.removeClass("open");
  });

  // Hero Fix
    // Find all sections on the page
    var sections = $('section');

    // Check if the first section's class list includes "bg-" or "-gradient"
    if (sections.length > 0 && ($(sections[0]).hasClass('bg-') || $(sections[0]).hasClass('-gradient'))) {
      // If the first section has "bg-" or "-gradient" in its class list, return false and do nothing
      return false;
    }

    // Variable to check if the .hero section has been found
    var foundHero = false;

    // Loop through each section
    sections.each(function(index, section) {
      // Check if the current section has the class 'hero'
      if ($(section).hasClass('hero')) {
        if (!$(section).hasClass('hero-overflow')) {
          foundHero = true; // Set the flag to true when the hero section is found
        }
      } else if (foundHero) {
        // If the hero section has been found, and the first section didn't have "bg-" or "-gradient", modify the class list of the next section

          // Check for 'py-10 py-lg-20 is present'
          if ($(section).hasClass('py-10 py-lg-20')) {
            $(section).removeClass('py-10 py-lg-20');
            $(section).addClass('pb-10 pb-lg-20');
          } else {
            $(section).removeClass('pt-10 pt-lg-20');
          }

        // Reset the flag to prevent further modifications to other sections
        foundHero = false;

        // Break the loop if you only want to modify the first section after the hero
        return false;
      }
    });

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };
});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();

  if ($('section.standard-hero').length > 0 || $('section.hero').length > 0) {
    if (scroll > 0) {
      $("header").addClass("scroll");
    } else {
      $("header").removeClass("scroll");
    }
  } else {
    $('header').addClass('scroll');
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($(".container-fix").length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1380,
    };

    let windowWidth = $(window).width();
    let containerWidth = 0;
    // let containerWidth = $(".container").width() + 32;

    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    if (containerWidth == 0) {
      console.error("containerWidth = 0 in Global.js on line: 213");
      return;
    } else {
      containerWidth += 32; // account for the padding on a bs container
    }

    // now calculate the padding for the offset on the content
    var padding = (windowWidth - containerWidth) / 2 + 16;

    if (windowWidth >= 992) {
      $(".container-fix").each(function () {
        if ($(this).hasClass("odd")) {
          $(this).css("padding-right", padding + "px");
        } else if ($(this).hasClass("even")) {
          $(this).css("padding-left", padding + "px");
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $(".container-fix").each(function () {
        $(this).css("padding-left", padding + "px");
        $(this).css("padding-right", padding + "px");
      });
    } else {
      $(".container-fix").each(function () {
        $(this).css("padding-left", "16px");
        $(this).css("padding-right", "16px");
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let headerHeight = $("#header").outerHeight();
  let dropdown = $("#navigation > ul li.nav-item .submenu");
  let megaMenu = $("#navigation > ul li.nav-item .submenu.mega-menu");
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;
  let headerPosition = headerHeight - 42;

  if (scroll == 0) {
    dropdown.css("top", headerPosition + "px");
    megaMenu.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + headerPosition + "px");
    megaMenu.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", headerPosition + "px");
    megaMenu.css("top", headerHeight + "px");
  }
};

/**
 * @description funtionality to add 15 divs to visible on view more button click for whitepapers
 */
 let showMoreItems = function($) {
  $.fn.showMoreItems = function(options) {
    return this.each(function() {
      var $container = $(this);
      var $cards = $container.find('.post-type-card');
      var $viewMoreBtn = $container.find('.view-more');
      var currentPage = 1;
      
      // Define itemsPerPage from options
      var itemsPerPage = options.itemsPerPage || 10; // Default to 10 itemsPerPage

      function showItems(page) {
        var startIndex = (page - 1) * itemsPerPage;
        var endIndex = startIndex + itemsPerPage;

        $cards.hide(); // Hide all cards
        $cards.slice(0, endIndex).show(); // Show cards up to endIndex

        // Check if there are more cards to show
        if (endIndex >= $cards.length) {
          $viewMoreBtn.hide();
        } else {
          $viewMoreBtn.show();
        }
      }

      $container.find('.view-more').on('click', function() {
        currentPage++;
        showItems(currentPage);
      });

      showItems(currentPage);
    });
  };
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".services-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
        }
      },
    ],
  });

  $(".whitepaper-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2.5,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3.5,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4.5,
        }
      },
    ],
  });

  $(".general-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2.5,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3.5,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4.5,
        }
      },
    ],
  });

  $(".timeline-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2.75,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3.75,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4.75,
        }
      },
    ],
  });

  $(".vacancies-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
        }
      },
    ],
  });

  $(".industry-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
        }
      },
    ],
  });

  $(".post-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
    ],
  });

  $(".partner-icon-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 7,
        }
      },
    ],
  });

  // slider arrow functionality
  // nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',/
  // prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
  // $('.slick-{arrow-name}.slick-prev').click(function () {
  //   $('.{carousel-name}').slick('slickPrev');
  // });
  // $('.slick-{arrow-name}.slick-next').click(function () {
  //   $('.{carousel-name}').slick('slickNext');
  // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);

  if($('.submenu').hasClass('open')) {
    $('.submenu').removeClass('open');
  }
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#d3d3d3",
          },
        ],
      },
      {
        featureType: "transit",
        stylers: [
          {
            color: "#808080",
          },
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#b3b3b3",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ffffff",
          },
          {
            weight: 1.8,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d7d7d7",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ebebeb",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#a7a7a7",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#efefef",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#696969",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#737373",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d6d6d6",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {},
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
    ],
    zoom: 12,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};
